import { z } from 'zod/v4'
import { baseModelSchema } from '../../libs/base-model.ts'

export const inventoryItemModelSchema = baseModelSchema.extend({
  name: z.string(),
  description: z.string().optional().nullable(),
  priceCents: z.int().positive(),
  imageUrl: z.string().optional().nullable(),
  webUrl: z.string().optional().nullable(),
  isFavorite: z.boolean(),
  isArchived: z.boolean(),
  imageKey: z.string().optional().nullable(),
  deletedAt: z.iso.datetime().optional().nullable(),
})
export type InventoryItemModel = z.infer<typeof inventoryItemModelSchema>

export const inventoryItemCreateSchema = z.object({
  name: z.string(),
  description: z.string().optional(),
  priceCents: z.coerce.number().int().positive(),
  image: z.any().optional(),
  webUrl: z.string().optional(),
})
export type InventoryItemCreate = z.infer<typeof inventoryItemCreateSchema>

export const inventoryItemUpdateSchema = z.object({
  name: z.string().optional(),
  description: z.string().optional(),
  priceCents: z.coerce.number().int().positive().optional(),
  image: z.any().optional().nullable(),
  webUrl: z.string().optional(),
  isFavorite: z.boolean().optional(),
  isArchived: z.boolean().optional(),
})
export type InventoryItemUpdate = z.infer<typeof inventoryItemUpdateSchema>
